<section class="content">
  <div class="content-block">
    <div class="block-header">
<!--      <app-breadcrumb-->
<!--        [active_item]="'Reportes'"-->
<!--        [items]="['Admin']"-->
<!--        [title]="'Reportes'"-->
<!--      ></app-breadcrumb>-->
    </div>
  </div>
</section>
